import FacebookTagInPostTriggerIntegrationInstructionsComponent from '@cohort/components-xps/components/apps/facebook/triggers/tagInPost/InstructionsComponent';
import type {FacebookTagInPostTriggerStruct} from '@cohort/shared/apps/facebook/triggers/tagInPost';
import {FacebookTagInPostTriggerSpec} from '@cohort/shared/apps/facebook/triggers/tagInPost';
import FacebookTagInPostTriggerActionCtaComponent from '@cohort/wallet/apps/facebook/triggers/tagInPost/ActionCtaComponent';
import type {TriggerIntegration} from '@cohort/wallet/apps/TriggerIntegration';

export const FacebookTagInPostTriggerIntegration: TriggerIntegration<FacebookTagInPostTriggerStruct> =
  {
    type: 'action',
    spec: FacebookTagInPostTriggerSpec,
    actionCtaComponent: FacebookTagInPostTriggerActionCtaComponent,
    instructionsComponent: FacebookTagInPostTriggerIntegrationInstructionsComponent,
  };
